import { useCallback, useState } from "react";

const useLinksNameDialog = () => {
    const [ isLinksNameDialogOpen, setIsLinksNameDialogOpen ] = useState(false);

    const handleLinksNameOpen = useCallback(
        () => {
            setIsLinksNameDialogOpen(true);
        },
        []
    );

    const handleLinksNameClose = useCallback(
        () => {
            setIsLinksNameDialogOpen(false);
        },
        []
    );

    return {
        isLinksNameDialogOpen,
        handleLinksNameOpen,
        handleLinksNameClose
    };
};

export default useLinksNameDialog;
